module.exports = __webpack_public_path__ + "img/gb6184.prt.cf7db7ff.jpg";